import * as React from 'react';
import { Numberbox, ValidationProps } from 'ui';
import { CodetableMetadata, CodeFieldWireKey } from '../../types-store';
import { CodetableTranslation } from '../../constants';
import { CodeItem } from 'app/area/indicator-factors/item/types-store';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

interface FactorProps {
  metadata: CodetableMetadata;
  readOnly?: boolean;
  codeItem: CodeItem;
  translation: CodetableTranslation;
  validation?: { [key: string]: ValidationProps };
  locale?: string;
  onChange: (key: CodeFieldWireKey, value: number) => void;
  resetValidation: (key: CodeFieldWireKey, value: number) => void;
  clearAllValidationData?: (key: CodeFieldWireKey) => void;
}

export const Factor = (props: FactorProps) => {

  const { readOnly, codeItem, translation, validation, locale } = props;

  const codetableKey = CodeFieldWireKey.factor;

  const onChange = (value: number) => {
    props.resetValidation(codetableKey, value);
    props.onChange(codetableKey, value);
    props.clearAllValidationData(codetableKey);
  };

  const currentValidation = !!validation && !!validation[codetableKey] ? validation[codetableKey] : undefined;

  return <div className="col-lg-4 col-sm-12">
    <Numberbox
      componentId={codetableKey}
      readOnly={readOnly}
      label={{ text: translation.factor, required: !readOnly }}
      value={(!!codeItem && isDefinedIncludingZero(codeItem[codetableKey])) ? codeItem[codetableKey] : undefined}
      validation={currentValidation}
      onChange={onChange}
      useThousand=" "
      minValue={-999999999999999.999999999999999}
      maxValue={999999999999999.999999999999999}
      maxDecimals={15}
      locale={locale}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;
};
